import { ApiTranslation } from '../../api/entities/translation.entity';
import { RecordType } from '../../records/entities/metadata/metadata.entity';
import { ExportProfileField, FacetProfileField, ProfileField } from './profile-field.entity';

export interface Profile {
    Name: string;
    Names: ApiTranslation[];
    Id: string;
    OrganisationId: number | null;
    RecordTypes: string[];
    Description?: string;
    Descriptions: ApiTranslation[];
    Fields: ProfileField[];
    Category: ProfileCategory;
    Tag: string;
    Row: number | null;
    Column: number | null;
}

export interface FacetProfile extends Profile {
    Fields: FacetProfileField[];
}
export interface ExportProfile extends Profile {
    Fields: ExportProfileField[];
}

export enum ProfileCategory {
    Base = 'Base',
    AdvancedSearch = 'AdvancedSearch',
    GenericList = 'GenericList',
    Facet = 'Facet',
    Classification = 'Classification',
    Export = 'Export',
    Ai = 'Ai',
    MetadataTranslation = 'MetadataTranslation'
}

export interface RestrictedProfile {
    Id: string;
    RecordTypes: RecordType[];
}

export interface RecordProfiles {
    Profiles: string[];
    RestrictedProfiles: RestrictedProfile[];
}
